module.exports = __webpack_public_path__ + "img/凯蒂猫.f536f00a.gif";